module.exports = "https://cdn2-fs.clearscore.com/flux/images/8d8a18bfad4c98da9c606fca1f185e66.png";